//@ts-nocheck

import {ReactNode, useState} from 'react';
import Link from 'next/link';
import {Customer} from '@delorand/db/schema/customer';
import {Input} from '@delorand/ui/src/input';
import {LoadingBlur} from '@delorand/ui/src/loader';
import Avatar from '@delorand/ui/src/radix/avatar';
import * as Drawer from '@delorand/ui/src/radix/dialog';
import {zodResolver} from '@hookform/resolvers/zod';
import {client} from 'c/utils/api';
import {CartReturn} from 'c/utils/cart';
import {Controller, useForm} from 'react-hook-form';
import {mutate} from 'swr';
import useSWRMutation from 'swr/mutation';
import {
  GroupCartS,
  groupCartS,
} from '../../../../../../packages/schema/dto/shared';

function NewGroup({
  children,
  userdata,
}: {
  userdata: Customer;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: {errors},
  } = useForm<GroupCartS>({
    resolver: zodResolver(groupCartS),
    defaultValues: {
      members: [],
      items: [],
    },
  });

  const {trigger, isMutating} = useSWRMutation(
    ['groupcart.create'],
    (_, {arg}: {arg: GroupCartS}) => {
      return '';
    },
    {
      onSuccess: () => {
        mutate(['cart.user']);
        setOpen(false);
        reset();
      },
    }
  );

  const getUserName = (id: string) =>
    userdata.friendTo?.find(x => x.id === id)?.userName;

  return (
    <Drawer.Root open={open} onOpenChange={setOpen}>
      {isMutating && <LoadingBlur />}
      <Drawer.Trigger>{children}</Drawer.Trigger>
      <Drawer.Portal>
        <Drawer.Overlay className="modal-overlay" />

        <Drawer.Content className="modal inset-x-0 bottom-0 h-[78vh] w-full rounded-t-xl border-t px-3 pt-4">
          <div className="mx-auto mb-4 h-1 w-12 shrink-0 rounded-full bg-zinc-300" />
          <h4 className="text-center text-[18px] font-medium">Group Cart</h4>
          <form
            onSubmit={handleSubmit(values => trigger(values))}
            className="flex h-full flex-col gap-1"
          >
            <Input
              label="Name"
              placeholder={`Group Name`}
              {...register('name')}
              error={errors.name?.message}
            />

            <Controller
              control={control}
              name="members"
              render={({field: {value, onChange}}) => (
                <>
                  {userdata.friendTo.length > 0 ? (
                    <div className="flex flex-1 flex-col">
                      {value.length > 0 && (
                        <>
                          <h5 className="mt-3 font-medium">Members</h5>
                          {errors.members && (
                            <p className="text-center text-xs text-red-600">
                              {errors.members.message?.toString()}
                            </p>
                          )}
                          <div className="flex min-h-12 w-full flex-wrap gap-2 rounded-xl border border-white/30 p-2">
                            {value.map(userId => (
                              <div
                                key={userId}
                                className="flex h-fit w-fit items-center gap-2 rounded-[8px] bg-white px-3 py-1 text-sm text-black"
                              >
                                <p className="">{getUserName(userId)}</p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    onChange(value.filter(x => x !== userId))
                                  }
                                >
                                  x
                                </button>
                              </div>
                            ))}
                          </div>
                        </>
                      )}

                      <h5 className="mt-3 text-lg font-medium">Friends </h5>
                      <div className="flex w-full flex-1 flex-col gap-2 overflow-y-auto p-4">
                        {userdata.friendTo
                          .filter(x => !value.includes(x.id))
                          .map(friend => (
                            <div
                              key={friend.id}
                              className="flex items-center gap-4"
                            >
                              <Avatar className="h-9 w-9 rounded-full" />
                              <div className="flex-1">
                                <h5 className="text-sm font-medium">
                                  {friend.userName}
                                </h5>
                                <h5 className="text-custom-neutral text-[13px]">
                                  {friend.bio || 'Delorand shopper'}
                                </h5>
                              </div>
                              <div>
                                <button
                                  type="button"
                                  className="btn-white py-1"
                                  onClick={() => {
                                    onChange([...value, friend.id]);
                                  }}
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          ))}
                      </div>

                      <button
                        type="submit"
                        className="btn-white mx-auto w-11/12"
                      >
                        Create
                      </button>
                    </div>
                  ) : (
                    <div className="mt-5 flex flex-col items-center">
                      <h4>You have not added any friend yet</h4>
                    </div>
                  )}
                </>
              )}
            />
            <Link
              href={'/account/friends'}
              className="btn-white mx-auto mt-5 w-fit"
            >
              Add Friends
            </Link>
          </form>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}

export default NewGroup;
